export const joinStringArraysInObject = (filterValues) => {
  // Creamos una copia del objeto para no modificar el original
  let newObj = { ...filterValues }
  // Iteramos sobre las claves del objeto
  for (let key in newObj) {
    // Verificamos si el valor asociado a la clave es un array
    if (Array.isArray(newObj[key])) {
      // Aplicamos join(',') si es un array de strings
      newObj[key] = newObj[key].join(',')
    }
  }
  return newObj
}
